import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../modules/infra/i18n';
import Money from '../../../common/money';

const TotalSection = ({ label, value }) => (
  <div className="layout__item u-1/5-medium-and-up u-fontsize-small u-mb0">
    <p className="u-type--semibold u-mv--">{label}</p>
    <p className="u-ph- u-pv-- u-bg-white">{value}</p>
  </div>
);

TotalSection.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.element, PropTypes.number]).isRequired,
};

const ShrinkageSummary = ({ summary }) => (
  <div className="layout u-mb+">
    <TotalSection label={t('products:reports.shrinkage.total_expected_label')} value={summary.totalExpected} />
    <TotalSection label={t('products:reports.shrinkage.total_counted_label')} value={summary.totalCounted} />
    <TotalSection
      label={t('products:reports.shrinkage.aggregate_shrinkage_cost_label')}
      value={<Money>{summary.totalShrinkageCost}</Money>}
    />
  </div>
);

ShrinkageSummary.propTypes = {
  summary: PropTypes.shape({
    totalCounted: PropTypes.number.isRequired,
    totalExpected: PropTypes.number.isRequired,
    totalShrinkageCost: PropTypes.number.isRequired,
  }).isRequired,
};

export default ShrinkageSummary;
